import $ from "cash-dom";

export default (function () {
    var selector = "a, button, input";

    function init() {
        if (!$(selector).length) return;

        jdmn.log("function_tab-focus.js initialized", "green");

        $("body").on("keyup", selector, function (_e) {
            if (_e.which == 9) {
                $(".tab-focus").removeClass("tab-focus");
                $(_e.target).addClass("tab-focus");
            }
        });
    }

    $(document).ready(init);
})();
